// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fLIA","productName":"Table_productName__xmKGo"};